import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  label?: string;
  separator?: ':';
};

function LabeledHorizontal({ children, label, separator = ':' }: Props) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm font-semibold">{`${label}${separator}`}</span>
      <>{children}</>
    </div>
  );
}

export default LabeledHorizontal;
